import type { GetSealedOrderDetailResponse } from '@/payment/types'

import { EditForm } from './components'

interface EditQuantityStepProps {
  detail: GetSealedOrderDetailResponse
  onCompleted: () => void
}

export function EditQuantityStep({ detail, onCompleted }: EditQuantityStepProps) {
  return (
    <EditForm
      detail={detail}
      onCompleted={onCompleted}
    />
  )
}
